import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
import { List, Loader, Message, Modal } from "semantic-ui-react";
import { WrapComponent } from "@iscr/views/UIelems/WrapComponent";
import { AsyncButton } from "@iscr/views/UIelems/AsyncButton";
import API_service from "@iscr/xAppLib/providers/API_service";
import { ensureIsError, rejectWithResErr } from "@iscr/xAppLib/helpers/rejectWithResErr";
import { consentFileUrl } from "@iscr/views/icosm/treatment/components/InformedConsent";
import { PreviewDocument } from "@iscr/views/UIelems/PreviewDocument";
function Layout({ children }) {
    return _jsx(WrapComponent, { title: "Preview Patient Forms", children: children });
}
function PreviewPatientForms() {
    const list = useAsync(() => {
        return API_service.api_promise("cosmetics/treatments/forms")
            .then(rejectWithResErr)
            .then(res => res.data)
            .catch(ensureIsError);
    });
    if (list.error) {
        return (_jsx(Layout, { children: _jsxs(Message, { error: true, children: [_jsx(Message.Header, { children: "Error loading consent forms" }), _jsxs(Message.Content, { children: [_jsx("p", { children: list.error.message }), _jsx(AsyncButton, { type: "button", basic: true, onClick: () => list.fn(), children: "Retry" })] })] }) }));
    }
    if (list.loading && !list.data) {
        return (_jsx(Layout, { children: _jsx(Loader, { active: true, inline: true }) }));
    }
    if (!list.data) {
        return (_jsx(Layout, { children: _jsx(Message, { error: true, header: "Error loading consent forms", content: "No data returned" }) }));
    }
    return (_jsx(Layout, { children: _jsx(List, { children: list.data.map((item, i) => (_jsx(List.Item, { children: _jsxs(List.Content, { className: "space-x-2", children: [_jsx(PreviewDocument, { className: null, viewOnly: true, doc_name: item.filename, url: consentFileUrl(item.filename) + "?sample=true", children: item.name }), item.legacy && _jsx(CompareForms, { filename: item.filename, title: item.name })] }) }, item.name + i))) }) }));
}
function CompareForms({ filename, title }) {
    return (_jsxs(Modal, { trigger: _jsx("a", { children: "(compare legacy form)" }), size: "fullscreen", closeIcon: true, closeOnEscape: true, children: [_jsx(Modal.Header, { children: title }), _jsx(Modal.Content, { children: _jsxs("div", { className: "flex flex-horizontal space-x-2", children: [_jsx("iframe", { src: consentFileUrl(filename) + "?sample=true", style: { width: "100%", height: "90vh" }, frameBorder: "0" }), _jsx("iframe", { src: consentFileUrl(filename) + "?legacy=true", style: { width: "100%", height: "90vh" }, frameBorder: "0" })] }) })] }));
}
export default React.memo(PreviewPatientForms);
